import { render } from "./ComponentBindModal.vue?vue&type=template&id=811a4a6a&scoped=true"
import script from "./ComponentBindModal.vue?vue&type=script&lang=js"
export * from "./ComponentBindModal.vue?vue&type=script&lang=js"

import "./ComponentBindModal.vue?vue&type=style&index=0&id=811a4a6a&lang=scss&scoped=true"

import exportComponent from "d:\\Beks\\EasyTicket\\easyticket.webshop.admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-811a4a6a"]])

export default __exports__